import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { AppointmentsTableComponent } from '../../components/appointments-table/appointments-table.component';
import { HttpService } from '../../services/http.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeleteModalComponent } from '../../components/delete-modal/delete-modal.component';
import { ModalAddNewRecordComponent } from '../../components/modals/modal-add-new-record/modal-add-new-record/modal-add-new-record.component';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-medical-record-recap',
  imports: [AppointmentsTableComponent, TranslateModule],
  templateUrl: './medical-record-recap.component.html',
  styleUrl: './medical-record-recap.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MedicalRecordRecapComponent implements OnInit {
  columns: any;
  type: string = '';
  rows?: any[];
  texts: any;

  constructor(
    private http: HttpService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private modal: NzModalService
  ) {}

  ngOnInit() {
    const url = new URL(window.location.href);
    this.type = url.searchParams.get('type')!;
    this.getTexts();
    this.translateService.onLangChange.subscribe(() => {
      this.getTexts();
    });
    this.getMedicalRecord();
  }

  protected getTexts() {
    this.translateService.get('medicalRecordRecap.text').subscribe((texts: any): void => {
      const typeTranslated = this.translateService.instant('medicalHistory.' + this.type + '.plural');
      this.texts = texts;
      this.texts.title = texts?.title?.replace('%type', typeTranslated);
      this.texts.secondTitle = texts?.secondTitle?.replace('%type', typeTranslated);
      this.texts.thirdTitle = texts?.thirdTitle?.replace('%type', typeTranslated);
      this.columns = texts.columns;
    });
  }

  protected getMedicalRecord() {
    this.http.getAllMedicalRecordByType(this.type!).subscribe((res: any) => {
      if (res) {
        this.rows = [];
        res.lista.forEach((medicalRecord: any) => {
          this.rows!.push({
            consultDate: medicalRecord.diagnosysDate ? this.parseCustomDate(medicalRecord.diagnosysDate) : this.parseCustomDate(medicalRecord.creationDatetime),
            time: medicalRecord.name ? medicalRecord.name : medicalRecord.intervention ? medicalRecord.intervention : medicalRecord.drugType ? medicalRecord.drugType : '-',
            name: medicalRecord.notes ? medicalRecord.notes : '-',
            startDate: this.type === 'drug' ? this.parseCustomDate(medicalRecord.reminderStartDate) : null,
            endDate: this.type === 'drug' ? this.parseCustomDate(medicalRecord.reminderEndDate) : null,
            dropdownRec: true,
            item: medicalRecord,
            key: this.type,
            misuration: true,
          });
        });
        this.cdr.detectChanges();
      }
    });
  }

  openModal() {
    const key = this.type;
    const modalRef = this.modal.create({
      nzContent: ModalAddNewRecordComponent,
      nzData: { key },
      nzFooter: null,
    });

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        this.getMedicalRecord();
      }
    });
  }

  private parseCustomDate(dateString: any) {
    const dateSplitted = dateString.split('T')[0];
    return dateSplitted.replaceAll('-', '/');
  }
}
